'use client';

import { useGetPlatformConfig } from '@morfi/backend-sdk-v2/client';

/**
 * Returns the live platform gift fee in basis points (FR-036).
 *
 * Reads `giftFeeBps` from the v2 SDK's `useGetPlatformConfig` — backed by the
 * `/v1/platform-config?kind=gift` endpoint, sourced from the latest
 * `GiftConfig` on-chain account. Returns `feeBps: 0` while the query is
 * pending so consumers can gate the fee preview UI on `isLoading`.
 */
export function useGiftFeeBps(): { feeBps: number; isLoading: boolean } {
  const { data, isPending } = useGetPlatformConfig({ kind: 'gift', fields: ['giftFeeBps'] });
  return {
    feeBps: data?.giftFeeBps ?? 0,
    isLoading: isPending,
  };
}
